import PropTypes from 'prop-types'
import React from 'react'
import css from './Overview.module.css'
import pluralize from 'pluralize'
import { SearchInput, Select, Button } from '@segment/react-ui-library'
import Tile from './Tile'
import SubNavigation from 'ui/SubNavigation'

export default function Overview (props) {
  const {
    name,
    description,
    requestUrl,
    metadataBaseUrl,
    metadatas,
    categories,
    platforms,
    searchTerm,
    onSearchChange,
    filterCategory,
    onCategoryFilter,
    filterPlatform,
    onPlatformFilter,
    onTileClick
  } = props

  return (
    <div>
      <SubNavigation title={`${pluralize(name)} Catalog`} />

      <div className={css.main}>
        <p className={css.description}>{description}</p>

        <div className={css.controls}>
          <div className={css.control}>
            <SearchInput
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder='Type to search…'
              width='280px' />
          </div>

          <div className={css.control}>
            <Select
              value={filterCategory}
              onChange={(e) => onCategoryFilter(e.target.value)}
              width='240px'>
              {categories.map(category => (
                <option key={category.value} value={category.value}>
                  {category.label}
                </option>
              ))}
            </Select>
          </div>

          {/* Optional because Sources don't have platforms */}
          {platforms &&
            <div className={css.control}>
              <Select
                value={filterPlatform}
                onChange={(e) => onPlatformFilter(e.target.value)}
                width='160px'>
                {platforms.map(platform => (
                  <option key={platform.value} value={platform.value}>
                    {platform.label}
                  </option>
                ))}
              </Select>
            </div>
          }
        </div>

        {metadatas.length > 0 ? (
          <div className={css.metadatas}>
            {metadatas.map(metadata => (
              <div className={css.metadata} key={metadata.slug}>
                <Tile
                  href={`${metadataBaseUrl}${metadata.slug}`}
                  image={metadata.logos.default}
                  title={metadata.name}
                  subtitle={metadata.categories[0]}
                  tag={getTag(metadata)}
                  onClick={() => onTileClick(metadata.slug)} />
              </div>
            ))}
          </div>
        ) : (
          <div className={css.noMatch}>
            <p className={css.noMatchText}>
              No {pluralize(name)} found
              {searchTerm && ` for ‘${searchTerm}’`}
            </p>

            <Button is='a' href={requestUrl}>
              Request {name}
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

Overview.displayName = 'Overview'

Overview.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  requestUrl: PropTypes.string.isRequired,
  metadataBaseUrl: PropTypes.string.isRequired,
  metadatas: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    categories: PropTypes.arrayOf(PropTypes.string).isRequired,
    logos: PropTypes.shape({
      default: PropTypes.string.isRequired
    }).isRequired,
    public: PropTypes.bool,
    visibility: PropTypes.string
  })).isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  platforms: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  searchTerm: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  filterCategory: PropTypes.string.isRequired,
  onCategoryFilter: PropTypes.func.isRequired,
  filterPlatform: PropTypes.string,
  onPlatformFilter: PropTypes.func,
  onTileClick: PropTypes.func.isRequired
}

function getTag (metadata) {
  // Integrations use `public`, Sources use `visibility`
  if (metadata.public === false) {
    return 'private'
  } else if (metadata.visibility !== 'live') {
    return metadata.visibility
  }
}



// WEBPACK FOOTER //
// ./components/Catalog/Overview.js